import styled from "styled-components";
import { detailActionButtonCss } from "../../shared/orderDesign/detailActionButtonCss";

const OutlineButton = styled.button`
  ${detailActionButtonCss}
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
`;

/** Outline action control for integration cards (Connect, etc.). */
export function IntegrationOutlineButton({
  children,
  title,
  onClick,
  disabled,
  type = "button",
  className,
}) {
  return (
    <OutlineButton
      type={type}
      className={className}
      disabled={disabled}
      onClick={onClick}
    >
      {children ?? title}
    </OutlineButton>
  );
}
